var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.023,
    height: 25.788,
    viewBox: "0 0 26.023 25.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3662",
    "data-name": "\\uADF8\\uB8F9 3662",
    transform: "translate(-1589.978 -976.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1701",
    "data-name": "\\uD328\\uC2A4 1701",
    d: "M19.993,10.747A9.246,9.246,0,1,1,10.746,1.5,9.247,9.247,0,0,1,19.993,10.747Z",
    transform: "translate(1590.32 976.878)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_2",
    "data-name": "\\uC120 2",
    x2: 6.282,
    y2: 6.279,
    transform: "translate(1608.35 994.521)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_922",
    "data-name": "\\uC0AC\\uAC01\\uD615 922",
    width: 26.023,
    height: 25.788,
    transform: "translate(1589.978 976.383)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-Search.69133e8491e657b5ce25889af1e85254.svg";
export { ForwardRef as ReactComponent };